import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Form, Icon, Input, Message, Modal, Popup } from 'semantic-ui-react'

import { trackEvent } from 'global-utils/Analytics'

import { authAction } from 'actions/AuthActions'
import { userRegister, userRegisterCanceled } from 'actions/RegisterActions'
import cloneDeep from 'lodash/cloneDeep'
import forIn from 'lodash/forIn'

import './Register.css'

class Register extends PureComponent {
  constructor(props) {
    super(props)
    this.TOTAL_DIRTIES = 9
    this.state = {
      fields: {
        day: '',
        email: '',
        firstname: '',
        gender: '',
        lastname: '',
        month: '',
        pass: '',
        year: '',
      },
      hidePassword: true,
      totalDirties: this.TOTAL_DIRTIES,
      updating: false,
    }
    this.providers = {
      count: 0,
    }
    this.dirties = {}
    this.errors = {}
    this.updatingTimeout = null

    this.props.userRegisterCanceled()
  }

  componentDidUpdate(prevProps) {
    if (this.state.updating && prevProps.error !== this.props.error) {
      this.startUpdateTimeout()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.updatingTimeout)
  }

  close = () => {
    this.props.userRegisterCanceled()
    this.props.onClose()
  }

  onChange = (field, event) => {
    const newState = cloneDeep(this.state)
    let value = `${event.target.value}`.trim()
    let error = false
    let errorField = field

    switch (field) {
      case 'birth': {
        errorField = 'birth'
        const birth = new Date(newState.fields.year, newState.fields.month, newState.fields.day)
        const minBirth = new Date()
        minBirth.setFullYear(new Date().getFullYear() - 14)
        const birthTime = birth.getTime()
        error = birthTime !== birth.getTime() || birth.getTime() > minBirth.getTime()
        break
      }
      case 'day': {
        errorField = 'birth'
        value = parseInt(event.target.value, 10)
        const birth = new Date(newState.fields.year, newState.fields.month, value)
        const minBirth = new Date()
        const birthTime = birth.getTime()
        minBirth.setFullYear(new Date().getFullYear() - 14)
        error = value <= 0 || value > 31 || birthTime !== birth.getTime() || birth.getTime() > minBirth.getTime()
        break
      }
      case 'email': {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        error = !value || value.length <= 1 || !re.test(value)
        break
      }
      case 'firstname':
      case 'lastname': {
        error = !value || value.length <= 2
        value = event.target.value || ''
        break
      }
      case 'gender': {
        error = value !== 'F' && value !== 'M'
        break
      }
      case 'month': {
        errorField = 'birth'
        value = parseInt(event.target.value, 10) - 1
        const birth = new Date(newState.fields.year, value, newState.fields.day)
        const minBirth = new Date()
        const birthTime = birth.getTime()
        minBirth.setFullYear(new Date().getFullYear() - 14)
        error = value < 0 || value > 11 || birthTime !== birth.getTime() || birth.getTime() > minBirth.getTime()
        break
      }
      case 'pass': {
        value = event.target.value || ''
        error = !value || value.length <= 5
        if (this.providers.count && !value) {
          error = false
        }
        break
      }
      case 'year': {
        errorField = 'birth'
        value = parseInt(event.target.value, 10)
        const birth = new Date(value, newState.fields.month, newState.fields.day)
        const minBirth = new Date()
        const birthTime = birth.getTime()
        minBirth.setFullYear(new Date().getFullYear() - 14)
        error = value <= 1920 || value > 2010 || birthTime !== birth.getTime() || birth.getTime() > minBirth.getTime()
        break
      }
      default: {
        break
      }
    }

    newState.fields[field] = value
    this.dirties[field] = true
    this.dirties[errorField] = true

    if (error) {
      this.errors[errorField] = true
    } else {
      delete this.errors[errorField]
    }
    this.setState(newState)
  }

  onFormSubmit = (event) => {
    event.preventDefault()
    const hasErrors = Object.keys(this.errors).length
    const totalDirties = Object.keys(this.dirties).length
    if (!this.state.updating && !hasErrors && totalDirties === this.state.totalDirties) {
      this.setState({
        updating: true,
      })

      trackEvent('Authentication', 'Signup', 'Attempt')

      this.props.userRegister({
        birth: new Date(this.state.fields.year, this.state.fields.month, this.state.fields.day).getTime() / 1000,
        email: this.state.fields.email,
        first_name: this.state.fields.firstname,
        gender: this.state.fields.gender,
        last_name: this.state.fields.lastname,
        password: this.state.fields.pass,
        password_confirmation: this.state.fields.pass,
        providers: encodeURIComponent(JSON.stringify(this.providers)),
        useCodeKey: true,
      })
    } else {
      forIn(this.state.fields, (value, key) => {
        this.onChange(key, { target: { value } })
      })
    }
  }

  onLoginClick = (event) => {
    event.preventDefault()
    this.props.authAction('login')
  }

  onPasswordResetClick = (event) => {
    event.preventDefault()
    this.props.authAction('reset')
  }

  onTogglePasswordVisibility = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.setState((prevState) => ({ hidePassword: !prevState.hidePassword }))
  }

  providerResponse = (response, provider) => {
    const newState = {}
    let providerData = {}

    switch (provider) {
      case 'facebook': {
        if (!response || response.status === 'not_authorized') {
          return
        }

        if (response.email) {
          newState.email = response.email
          this.dirties.email = true
        }
        if (response.first_name) {
          newState.firstname = response.first_name
          this.dirties.firstname = true
        }
        if (response.last_name) {
          newState.lastname = response.last_name
          this.dirties.lastname = true
        }
        if (response.birthday) {
          const bd = moment(response.birthday)
          newState.year = bd.year()
          newState.month = bd.month()
          newState.day = bd.date()

          this.dirties.year = true
          this.dirties.month = true
          this.dirties.day = true
          this.dirties.birth = true
        }
        if (response.gender) {
          if (response.gender === 'male') {
            newState.gender = 'M'
            this.dirties.gender = true
          } else if (response.gender === 'female') {
            newState.gender = 'F'
            this.dirties.gender = true
          }
        }

        this.dirties.pass = true

        providerData = response

        break
      }
      default: {
        return
      }
    }

    if (!this.providers[provider]) {
      this.providers.count += 1
    }
    this.providers[provider] = cloneDeep(providerData)
    this.setState(newState)
    this.onFormSubmit({
      preventDefault: Function.prototype,
    })
  }

  startUpdateTimeout = () => {
    clearTimeout(this.updatingTimeout)
    this.updatingTimeout = setTimeout(() => this.setState({ updating: false }), 1000 * 7)
  }

  static renderPopup(label, message) {
    return (
      <label>
        {label}{' '}
        <Popup
          size="mini"
          trigger={
            <sup>
              <Icon name="question" />
            </sup>
          }
        >
          {message}
        </Popup>
      </label>
    )
  }

  render() {
    const { error, open } = this.props
    const { updating } = this.state
    let errorMsg = null
    if (error) {
      const content = []
      Object.values(error?.response?.data?.[0] || {}).forEach((errorsMessages) => {
        content.push(...errorsMessages)
      })

      errorMsg = (
        <Message content={content.length > 0 ? content.map((msg) => <div key={msg}> - {msg}</div>) : error.msg} error />
      )
    }
    const hasErrors = Object.keys(this.errors).length > 0

    return (
      <Modal className="ModalRegister" closeIcon="close" onClose={this.close} open={open} size="small">
        <Modal.Header>Regístrate en SweatBits</Modal.Header>
        <Modal.Content>
          <Form key="mini" as="form" error={!!error || hasErrors} onSubmit={this.onFormSubmit} size="mini">
            <Form.Group className="cols2">
              <Form.Field
                autoComplete="given-name"
                control="input"
                error={!!this.errors.firstname}
                label="Nombres"
                onChange={(e) => this.onChange('firstname', e)}
                placeholder="Nombres"
                value={this.state.fields.firstname}
              />
              <Form.Field
                autoComplete="family-name"
                control="input"
                error={!!this.errors.lastname}
                label="Apellidos"
                onChange={(e) => this.onChange('lastname', e)}
                placeholder="Apellidos"
                value={this.state.fields.lastname}
              />
            </Form.Group>
            <Form.Group className="cols4">
              <Form.Input
                autoComplete="bday-day"
                error={!!this.errors.birth}
                label={Register.renderPopup('Nací el', 'Debes tener 14+ años para ingresar.')}
                onChange={(e) => this.onChange('day', e)}
                placeholder="Día"
                type="number"
                value={this.state.fields.day}
              />
              <Form.Input
                autoComplete="bday-month"
                error={!!this.errors.birth}
                label="&nbsp;"
                onChange={(e) => this.onChange('month', e)}
                placeholder="Mes"
                type="number"
                value={this.state.fields.month === '' ? '' : this.state.fields.month + 1}
              />
              <Form.Input
                autoComplete="bday-year"
                className="ModalRegister__year"
                error={!!this.errors.birth}
                label="&nbsp;"
                onChange={(e) => this.onChange('year', e)}
                placeholder="Año"
                type="number"
                value={this.state.fields.year}
              />
              <Form.Field className="ModalRegister__gender" error={!!this.errors.gender}>
                {Register.renderPopup('Género', 'Para ubicarte en torneos relativos.')}
                <Button.Group basic size="tiny">
                  <Button
                    basic
                    color={this.state.fields.gender === 'F' ? 'green' : null}
                    icon="female"
                    onClick={() => this.onChange('gender', { target: { value: 'F' } })}
                    type="button"
                  />
                  <Button.Or text="o" />
                  <Button
                    basic
                    color={this.state.fields.gender === 'M' ? 'green' : null}
                    icon="male"
                    onClick={() => this.onChange('gender', { target: { value: 'M' } })}
                    type="button"
                  />
                </Button.Group>
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                autoComplete="email"
                control="input"
                error={!!this.errors.email}
                label="E-mail"
                onChange={(e) => this.onChange('email', e)}
                placeholder="E-mail"
                type="email"
                value={this.state.fields.email}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <Input
                  autoComplete="new-password"
                  control="input"
                  error={!!this.errors.pass}
                  iconPosition="right"
                  label="Contraseña"
                  onChange={(e) => this.onChange('pass', e)}
                  placeholder="Contraseña 6+"
                  type={this.state.hidePassword ? 'password' : 'text'}
                >
                  <input />
                  <Icon
                    className="z-10 pointer-events-auto	"
                    link
                    name={this.state.hidePassword ? 'eye' : 'eye slash outline'}
                    onClick={this.onTogglePasswordVisibility}
                  />
                </Input>
              </Form.Field>
            </Form.Group>
            <div className="ModalRegister__terms">
              Al registrarte, aceptas las
              <Link className="text-green" target="_blank" to="/platform/privacy">
                {' '}
                Condiciones de Servicio{' '}
              </Link>
              y
              <Link className="text-green" target="_blank" to="/platform/privacy">
                {' '}
                Política de Privacidad
              </Link>
              , incluyendo el{' '}
              <Link className="text-green" target="_blank" to="/platform/privacy">
                Uso de Cookies
              </Link>
              .
            </div>
            <Button className={`ModalRegister__button ${updating ? 'loading disabled' : 'primary'}`} type="submit">
              Registrarme
            </Button>
            {errorMsg}
          </Form>
          <div className="flex justify-between text-sm text-green">
            <a className="py-2" href="/" onClick={this.onPasswordResetClick}>
              Olvidé mi contraseña
            </a>
            <a className="py-2" href="/" onClick={this.onLoginClick}>
              Login
            </a>
          </div>
        </Modal.Content>
      </Modal>
    )
  }
}

Register.propTypes = {
  authAction: PropTypes.func.isRequired,
  userRegister: PropTypes.func.isRequired,
  userRegisterCanceled: PropTypes.func.isRequired,

  environment: PropTypes.object,
  error: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
}

Register.defaultProps = {
  environment: {},
  error: null,
  onClose: Function.prototype,
  open: false,
}

export default connect(({ environment, register: { error } }) => ({ environment, error }), {
  authAction,
  userRegister,
  userRegisterCanceled,
})(Register)
